import { render, staticRenderFns } from "./UpdatePriceModal.vue?vue&type=template&id=36c12385&scoped=true&"
import script from "./UpdatePriceModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c12385",
  null
  
)

export default component.exports